let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("22B8X")).then(() => parcelRequire('9wRCh'));